import React from 'react';
import {
  faBuilding,
  faLaptopCode,
  faRocket,
  faTrophy,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SCLA_HIGHLIGHTS } from '../../copy/sclaProgramCopy';
import styles from './SclaHighlights.module.scss';

const ICONS = [faRocket, faLaptopCode, faTrophy, faBuilding];

/** The SCLA highlight tiles. Used on the public landing page and the application home. */
export default function SclaHighlights() {
  return (
    <ol className={styles.highlights}>
      {SCLA_HIGHLIGHTS.map((item, index) => (
        <li key={item.title} className={styles.highlight}>
          <span className={styles.icon} aria-hidden="true">
            <FontAwesomeIcon icon={ICONS[index % ICONS.length]} />
          </span>
          <span className={styles.title}>{item.title}</span>
          <span className={styles.body}>{item.body}</span>
        </li>
      ))}
    </ol>
  );
}
